import React from 'react';

const signedInNextActions = [
  {
    alt: 'Start a new document',
    cta: 'Start a New Document',
    href: '/document-library',
    onClick: () => { window._track('Start a New Document | Recipient Builder', 'Recipient Builder'); },
    src: 'images/self-serve-recipient-builder/start-new-icon-2x.png',
  },
  {
    actionId: 'uploadPDF',
    alt: 'Upload a PDF to Edit',
    cta: 'Upload a PDF to Edit',
    onClickDiv: () => { window._track('Upload PDF | Recipient Builder', 'Recipient Builder'); },
    src: '/images/self-serve-recipient-builder/start-new-to-edit-2x.png',
  },
  {
    alt: 'Go to My Documents',
    cta: 'Go to My Documents',
    href: '/my-documents',
    onClick: () => { window._track('My Documents | Recipient Builder', 'Recipient Builder'); },
    src: '/images/self-serve-recipient-builder/go-to-my-docs-2x.png',
    style: { width: '67px', marginTop: '9px' },
  },
];

class SelfServeRecipientBuilderFinishedSideBarLoggedIn extends React.PureComponent {

  componentDidMount() {
    window.Upload.activateUploadButtonById('uploadPDF', 'freewrite');
  }

  render() {
    return (
      <React.Fragment>
        <div className="row self-serve-recipient-response-sent-next-actions-wrapper">
          { signedInNextActions.map(action => (
            <div
              id={action.actionId || ''}
              onClick={action.onClickDiv || (() => null)}
              className="span3 self-serve-recipient-response-sent-next-action"
            >
              <div className="row-fluid">
                <div className="span12">
                  <div className="self-serve-recipient-response-sent-next-action-icon-wrapper">
                    <img
                      alt={action.alt}
                      className="self-serve-recipient-response-sent-next-action-icon"
                      src={action.src}
                      style={action.style || {}}
                    />
                  </div>
                </div>
              </div>
              <div className="row-fluid">
                <div className="span12">
                  <div className="self-serve-recipient-response-sent-next-action-cta-wrapper">
                    <a
                      href={action.href || '#'}
                      className="self-serve-recipient-response-sent-next-action-cta"
                      onClick={action.onClick || null}
                    >
                      { action.cta}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            ))
          }
        </div>
      </React.Fragment>
    );
  }
}

export default SelfServeRecipientBuilderFinishedSideBarLoggedIn;



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/RecipientFinishedSideBar/SelfServeRecipientBuilderFinishedSideBarLoggedIn.jsx